import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export type ImsInvoiceStatus = z.infer<typeof imsInvoiceStatus>;
export const imsInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentImsInvoice = {
  name: "getCurrentImsInvoice" as const,
  input: z.null(),
  output: imsInvoiceStatus.nullable(),
};
